import useProductListingData from 'hooks/useProductListingData';
import { GET_CATEGORY_PAGE } from 'mocks/queries';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';

const useCategoryPageData = ({ slug, serverData }) => {
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? '';

  const pageData = useProductListingData(GET_CATEGORY_PAGE, {
    variables: {
      slug,
      zipCode,
      ...getVisitorLocationQueryVariables(userLocation?.stateShortName),
    },
    serverData,
  });

  return pageData;
};

export default useCategoryPageData;
